import {
  SET_DATA,
  SET_VALUE,
  SET_ARRAY,
  CLEAR_DATA
} from './mutation-types'

import {state} from './state'
const _ = require('lodash')
const f = require('../lib/functions')

export default {
  [SET_DATA](state, request){
    state.data = {
      ...state.data,
      [request.key]: {...request.data}
    }
  },
  [SET_VALUE](state, request){
    state.data = {
      ...state.data,
      [request.key]: request.value
    }
  },
  [SET_ARRAY](state, request){
    state.data = {
      ...state.data,
      [request.key]: [...request.data]
    }
  },
  [CLEAR_DATA](state, request){
    _.forEach(request, (i)=>{
      delete state.data[i]
    })
  },
}
